// extracted by mini-css-extract-plugin
export default {"customersPage":"Customers_customersPage__dBfXx"};